export default {
  title: 'Módulos',
  description: 'Cadastre as funcionalidades disponíveis no sistema e defina sua apresentação, vínculos, dependências e disponibilidade para acesso.',
  form: {
    title: 'Cadastro de Módulo',
    groups: {
      data: 'Dados do Módulo',
    },
  },
  images: {
    light: 'Light',
    dark: 'Dark',
  },
  labels: {
    new: 'Novo Módulo',
    profiles: 'Perfis Liberados',
    included: 'Inclusos',
    dependencies: 'Dependências',
    recommendations: 'Recomendações',
    selection: 'Seleção de Módulos',
  },
  fields: {
    name: 'Nome do Módulo',
    active: 'Ativo',
    humanAclAssignable: 'Disponível para ACL humana',
    header: 'Imagem de Cabeçalho',
    byokPolicy: 'BYOK',
    trialPolicy: 'Trial',
  },
  byok: {
    options: [
      { text: 'Platform', value: 'platform' },
      { text: 'BYOK', value: 'byok' },
      { text: 'Both', value: 'both' },
    ],
    errors: {
      unsupported: 'Este Module não possui integração técnica compatível com a origem de credenciais selecionada.',
      partialRequiresByok: 'A política Partial exige BYOK ou Both.',
      required: 'Selecione uma política BYOK válida.',
    },
  },
  trial: {
    options: [
      { text: 'Free', value: 'free' },
      { text: 'Partial', value: 'partial' },
      { text: 'Restricted', value: 'restricted' },
      { text: 'Blocked', value: 'blocked' },
    ],
    errors: { required: 'Selecione uma política Trial válida.' },
  },
  tabs:{
    relationship: 'Relacionamento entre módulos',
    profiles: 'Módulos por perfil'
  }
};
